import React, { useEffect, useState } from 'react';
import { formatCurrency, apiFetch } from "utils";
import PropTypes from 'prop-types';
import registeredComponent from 'utils/registeredComponent';
import Placeholder from 'components/Placeholder';
import TotalsHeader from '../shared/TotalsHeader'

/**
 * Shows a header with the totals for the fields listed in the columns prop.
 */
const SummaryTotalsHeader = ({apiPath, columns, data}) => {
  const [ready, setReady] = useState(false);
  const [totals, setTotals] = useState({});

  useEffect(
    () => {
      if (data !== null && Object.keys(data).length > 0) {
        setTotals(data);
        setReady(true);
      }
      else {
        apiFetch.get(totals, apiPath)
          .then(json => {
            setTotals(json);
            setReady(true);
          });
      }
    }, [apiPath, data]
  );

  const columnValues = columns.map((column) => formatCurrency(totals[column.name]));

  return (
    <Placeholder.loading ready={ready}>
      <TotalsHeader columnHeaders={columns.map((column) => column.publicName)} columnValues={columnValues} />
    </Placeholder.loading>
  );
}

SummaryTotalsHeader.propTypes = {
  apiPath: PropTypes.string,
  data: PropTypes.object,
  columns: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, publicName: PropTypes.string }))
};

SummaryTotalsHeader.defaultProps = {
  apiPath: '',
  data: {},
  columns: [],
};

export default registeredComponent("SummaryTotalsHeader")(SummaryTotalsHeader);
